<template>
  <div>
    <div class="lnb-list">
      <ul>
        <li>
          <a href="#" @click.prevent="moveToUrl()">
            <span>{{title}}</span>
            <NextButtonWhite></NextButtonWhite>
          </a>
        </li>
      </ul>
    </div>

  </div>
</template>

<script>
import NextButtonWhite from '@/assets/svg/common/ic-next-s-w.svg'
import { get } from 'lodash'
import { parseUrl, stringify } from 'query-string'
export default {
  name: 'TemplateTextButton',
  components: {
    NextButtonWhite
  },
  props: {
    sectionInfo: {
      type: Object
    }
  },
  computed: {
    title () {
      return get(this.sectionInfo, 'title', '')
    }
  },
  methods: {
    moveToUrl () {
      const { url, query } = parseUrl(get(this.sectionInfo, 'viewMoreEvent.url', ''))
      let newUrl = url
      newUrl = newUrl.replace('https://', '')
      newUrl = newUrl.replace('http://', '')
      newUrl = newUrl.replace('m.pooq.co.kr', '')
      newUrl = newUrl.replace('www.pooq.co.kr', '')
      newUrl = newUrl.replace('www.wavve.com', '')
      newUrl = newUrl.replace('m.wavve.com', '')
      newUrl = newUrl.replace('.html', '')
      this.$router.push(newUrl + '?' + stringify(query))
    }
  }
}
</script>
